import { useAuth } from "@/context/AuthContext";

/**
 * Hook to check if the current user is an admin
 * @returns boolean indicating if user is admin
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === "ADMIN";
}

